"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONE_ADDRESS = exports.ZERO_ADDRESS = void 0;
exports.ZERO_ADDRESS = '0x' + '0'.repeat(40);
exports.ONE_ADDRESS = '0x' + '0'.repeat(39) + '1';
